import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aboutrewards',
  templateUrl: './aboutrewards.component.html',
  styleUrls: ['./aboutrewards.component.css']
})
export class AboutrewardsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
